import PageSEO from '../components/PageSEO';
import React, { useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Mail, Lock, AlertCircle } from 'lucide-react';
import Header from '../components/Header';
import Footer from '../components/Footer';

const LoginPage = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const redirectTo = searchParams.get('redirect') || '/dashboard';

  const formatApiErrorDetail = (detail) => {
    if (detail == null) return "Bir hata oluştu. Lütfen tekrar deneyin.";
    if (typeof detail === 'string') return detail;
    if (Array.isArray(detail)) return detail.map(e => e?.msg || JSON.stringify(e)).filter(Boolean).join(' ');
    if (detail?.msg) return detail.msg;
    return String(detail);
  };

  const handleSubmit = async (e) => {
    e.preventDefault(); setError(''); setLoading(true);
    try { await login(email, password); navigate(redirectTo); }
    catch (err) { setError(formatApiErrorDetail(err.response?.data?.detail) || err.message); }
    finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen flex flex-col" style={{ background: 'linear-gradient(180deg, #15263A 0%, #1E3348 80px, #F8F6F3 80px, #F8F6F3 100%)' }}>
      <PageSEO title="Giriş Yap" description="DoktorCebinde hesabınıza giriş yapın" />
      <Header />

      <div className="flex-1 flex items-center justify-center py-16 px-4">
        <div style={{ maxWidth: 420, width: '100%' }}>
          <div style={{ background: '#fff', border: '1px solid #ECE7E1', borderRadius: 14, padding: 40 }} data-testid="login-form-card">
            <div className="text-center mb-8">
              <h2 style={{ fontSize: 28, fontWeight: 700, color: '#1A2B3C', letterSpacing: '-0.02em' }}>
                Giriş Yap
              </h2>
              <p style={{ fontSize: 15, color: '#687482', marginTop: 8 }}>
                Hesabınıza giriş yapın
              </p>
            </div>

            {error && (
              <div className="mb-5 flex items-start gap-2 p-3" style={{ background: 'rgba(239,68,68,0.05)', border: '1px solid rgba(239,68,68,0.12)', borderRadius: 10 }} data-testid="login-error-message">
                <AlertCircle className="w-4 h-4 text-red-500 shrink-0 mt-0.5" />
                <p style={{ fontSize: 13, color: '#DC2626', margin: 0 }}>{error}</p>
              </div>
            )}

            <form onSubmit={handleSubmit} className="space-y-4">
              <div>
                <label style={{ display: 'block', fontSize: 13, fontWeight: 500, color: '#435160', marginBottom: 6 }}>E-posta</label>
                <div className="relative">
                  <Mail className="absolute left-3 top-1/2 -translate-y-1/2" style={{ width: 16, height: 16, color: '#94A3B8' }} />
                  <input type="email" value={email} onChange={e => setEmail(e.target.value)}
                    style={{ width: '100%', height: 46, borderRadius: 10, background: '#FAF8F5', border: '1px solid #ECE7E1', paddingLeft: 38, paddingRight: 14, fontSize: 14, color: '#1A2B3C', outline: 'none' }}
                    placeholder="ornek@email.com" required data-testid="login-email-input" />
                </div>
              </div>

              <div>
                <label style={{ display: 'block', fontSize: 13, fontWeight: 500, color: '#435160', marginBottom: 6 }}>Şifre</label>
                <div className="relative">
                  <Lock className="absolute left-3 top-1/2 -translate-y-1/2" style={{ width: 16, height: 16, color: '#94A3B8' }} />
                  <input type="password" value={password} onChange={e => setPassword(e.target.value)}
                    style={{ width: '100%', height: 46, borderRadius: 10, background: '#FAF8F5', border: '1px solid #ECE7E1', paddingLeft: 38, paddingRight: 14, fontSize: 14, color: '#1A2B3C', outline: 'none' }}
                    placeholder="••••••••" required data-testid="login-password-input" />
                </div>
              </div>

              <div className="flex justify-end">
                <Link to="/forgot-password" style={{ fontSize: 13, color: '#D88A61', fontWeight: 500, textDecoration: 'none' }} data-testid="forgot-password-link">
                  Şifremi Unuttum
                </Link>
              </div>

              <button type="submit" disabled={loading} className="w-full disabled:opacity-50" style={{
                background: '#1A2B3C', color: '#fff', borderRadius: 4, padding: '14px',
                fontWeight: 600, fontSize: 15, border: 'none', cursor: 'pointer',
                transition: 'all 0.2s',
              }} data-testid="login-submit-button">
                {loading ? 'Giriş Yapılıyor...' : 'Giriş Yap'}
              </button>
            </form>

            <div className="mt-6 text-center">
              <p style={{ fontSize: 13, color: '#687482' }}>
                Hesabın yok mu?{' '}
                <Link to="/register" style={{ color: '#D88A61', fontWeight: 600, textDecoration: 'none' }} data-testid="register-link">Kayıt Ol</Link>
              </p>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default LoginPage;
